import React from "react";
import "./_club-tile-version-2.scss";
import {ClubType} from "../../../../types/ApiTypeDefinition/clubFinderResultTypes";
import {Config, TenantAppVersionConfig, ignoredInclusions} from "../../../../constants/Config";
import {useSelector} from "react-redux";
import {RootState} from "../../../../store/configureStore";
import {InclusionType} from "../../../../types/ApiTypeDefinition/singleClubFinderResultTypes";

const baseClass = 'club-tile-version-2';

interface ClubTilePropType {
  clubDetails: ClubType
  clubTileContainerStyles?: string
  index: any
  handleClubTileAction?: any
  clubLogoVisible?: boolean
  tenant: string
}

const ClubTileVersion2 = (props: ClubTilePropType): JSX.Element => {
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);
  const defaultSearchLogo = Config.search.defaultLogos[tenant];
  let clubAddressText = ''
  let clubFormatTags;
  if (props.clubDetails.address) {
    clubAddressText = `${props.clubDetails.address.line1 ? `${props.clubDetails.address.line1},` : ''}${props.clubDetails.address.suburb ? ` ${props.clubDetails.address.suburb}` : ''}${props.clubDetails.address.state ? `, ${props.clubDetails.address.state}` : ''}`
  }
  let clubLogoUrlEnhanced = props.clubDetails.orgLogo;
  if (props.clubDetails.orgLogo) {
    clubLogoUrlEnhanced = props.clubDetails.orgLogo.replace('h_32', 'h_64');
    clubLogoUrlEnhanced = clubLogoUrlEnhanced.replace('w_32', 'w_64');
  }

  const formattedInclusionItems = props.clubDetails.inclusions ? props.clubDetails.inclusions.filter((item: InclusionType) => !ignoredInclusions[tenant].includes(item.inclusionPlayHQValue)) : null;

  if (formattedInclusionItems && formattedInclusionItems.length > 0) {
    clubFormatTags = formattedInclusionItems ?  formattedInclusionItems.map((inclusionItem: any, index: number) =>
      <div className={`filter-tags`} key={index}>
        {inclusionItem.inclusionDisplayValue}
      </div>
    ) : null;
  }

  const {min_age, max_age, gender} = props.clubDetails.demographics;
  const formattedGender = gender ? gender.replaceAll(',', ', ') : null;

  return (
    <div className={[baseClass, props.clubTileContainerStyles].join(' ')} key={props.index}
         onClick={() => props.handleClubTileAction(props.clubDetails.orgId, props.clubDetails.distance)}>
      <div className={`${baseClass}--tile-details-container`}>
        <div className={`${baseClass}--tile-details-wrapper`}>
          {props.clubLogoVisible && props.clubDetails.orgLogo && (
            <div className={'clubLogoContainer'}>
              {props.clubDetails.orgLogo && (
                <img src={clubLogoUrlEnhanced} className={'clubLogoImage'} alt="logo"/>
              )}
            </div>
          )}
          {props.clubLogoVisible && !props.clubDetails.orgLogo && (
            <div className={'clubLogoContainer'}>
                <img src={defaultSearchLogo} className={'clubLogoImage default'} alt="logo"/>
            </div>
          )}
          <div className={`${baseClass}--content`}>
            {props.clubDetails.orgName && (
              <div className={'clubName'}>{props.clubDetails.orgName}</div>
            )}
            {tenant == Config.tenantList.naTenant && props.clubDetails.distance && (
              <div
                className={'distanceText'}>{Math.round((parseFloat(props.clubDetails.distance) + Number.EPSILON) * 100) / 100} KM
              </div>
            )}
            {tenant == Config.tenantList.aflTenant && props.clubDetails.address && (
              <div
                className={'clubAddress'}>{clubAddressText}</div>
            )}
          </div>
        </div>
        {tenant == Config.tenantList.naTenant && props.clubDetails.address && (
          <div
            className={'clubAddress'}>{clubAddressText}</div>
        )}
        <div className={`${baseClass}--filter-wrapper`}>
          <div className={`filter-text`}>
            {formattedGender ? `${formattedGender}` : ''} {(formattedGender && min_age >= 0 ) ? ' • ' : ''} {min_age >= 0 && max_age >= 0 ? `Ages ${min_age} - ${max_age}` : ''} </div>
          {clubFormatTags && (
            <div className={`filter-container`}>
              {clubFormatTags}
            </div>
          )}
        </div>
      </div>
      <div className={`${baseClass}--distance-chevron-wrapper`}>
        {tenant == Config.tenantList.aflTenant && props.clubDetails.distance && (
          <div
            className={'distanceText'}>{Math.round((parseFloat(props.clubDetails.distance) + Number.EPSILON) * 100) / 100} KM
          </div>
        )}
        <img src={TenantAppVersionConfig[props.tenant].icons.chevronDown} className={'chevron-right'} alt="logo"/>
        <div></div>
      </div>
    </div>
  )
}

export default ClubTileVersion2;
